(function(){
  "use strict";

  var COLORS = ["RED","GREEN","BLUE"];
  var ACCENTS = { RED: "#ff3d3d", GREEN: "#4dffa3", BLUE: "#57b6ff" };
  var index = 0;

  var machineImgs = document.querySelectorAll(".machine-img");
  var glows = document.querySelectorAll(".glow");
  var signGlow = document.getElementById("signGlow");
  var knobGlow = document.getElementById("knobGlow");
  var buttonGlow = document.getElementById("buttonGlow");

  function applyColor(color){
    var accent = ACCENTS[color];

    machineImgs.forEach(function(img){
      img.classList.toggle("is-active", img.dataset.color === color);
    });
    glows.forEach(function(g){
      g.classList.toggle("is-active", g.dataset.color === color);
    });

    var dotGlow = "radial-gradient(circle, #ffffff 0%, " + accent + " 40%, transparent 72%)";
    var barGlow = "radial-gradient(ellipse, #ffffff 0%, " + accent + " 45%, transparent 75%)";
    signGlow.style.background = barGlow;
    knobGlow.style.background = dotGlow;
    buttonGlow.style.background = dotGlow;
  }

  applyColor(COLORS[index]);
  setInterval(function(){
    index = (index + 1) % COLORS.length;
    applyColor(COLORS[index]);
  }, 3200);
})();
